import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './BottomMobileMenu.module.scss'
import { routes, mainMenu, mainMenuRules } from '../../imports/config'
import { useMedia } from 'react-use'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { find } from 'lodash'
import SearchIcon from '../../assets/icons/search_outline.svg'
import SearchIconOutline from '../../assets/icons/search.svg'
import ReservationsIcon from '../../assets/icons/work_outline-24px.svg'
import ReservationsIconOutline from '../../assets/icons/work-24px.svg'
import ProfileIcon from '../../assets/icons/account_circle-24px.svg'
import ProfileIconOutline from '../../assets/icons/account_circle-24px-outline.svg'
import LoginIcon from '../../assets/icons/login-24px.svg'
import RegisterIcon from '../../assets/icons/person_add-24px.svg'
import CoworkingIcon from '../../assets/icons/coworking.svg'
import CoworkingIconOutline from '../../assets/icons/coworking_outline.svg'

const menuIcons = {
    search: SearchIcon,
    search_outline: SearchIconOutline,
    reservations: ReservationsIcon,
    reservations_outline: ReservationsIconOutline,
    profile: ProfileIcon,
    profile_outline: ProfileIconOutline,
    login: LoginIcon,
    register: RegisterIcon,
    coworking_outline: CoworkingIcon,
    coworking: CoworkingIconOutline,
}

const MenuIcon = ({ className, iconName, iconAlt, outlined }) => {
    const { t } = useTranslation()
    return (
        <img
            className={styles.bottomMenuIcon}
            src={menuIcons[`${iconName}${outlined ? '_outline' : ''}`]}
            alt={t(iconAlt)}
        />
    )
}

const BottomMenu = props => {
    const { t } = useTranslation()
    const isMobile = useMedia('(max-width: 767px)')
    const location = useLocation()
    const history = useHistory()
    const role = props.user?.role || 'guest'

    const actualPath = find(routes, route =>
        matchPath(location.pathname, { path: route.path, exact: true })
    )

    if (isMobile && actualPath.hasBottomMenu) {
        return (
            <div className={styles.bottomMenuWrapper}>
                {mainMenuRules()[role].map((item, index) => {
                    if (mainMenuRules()[role][index].visibility.includes('m')) {
                        return (
                            <div
                                key={mainMenu[item.key].text}
                                className={`${
                                    location.pathname === mainMenu[item.key].url
                                        ? styles.selectedLink
                                        : ''
                                } ${styles.menuLink}`}
                                onClick={() =>
                                    history.push(mainMenu[item.key].url)
                                }
                            >
                                <MenuIcon
                                    iconName={mainMenu[item.key].icon}
                                    iconAlt={mainMenu[item.key].iconAlt}
                                    outlined={
                                        location.pathname ===
                                        mainMenu[item.key].url
                                    }
                                />
                                <span className={styles.bottomMenuIconText}>
                                    {t(mainMenu[item.key].text)}
                                </span>
                            </div>
                        )
                    } else {
                        return null
                    }
                })}
            </div>
        )
    } else {
        return null
    }
}

export default BottomMenu
